import { render, staticRenderFns } from "./UpdateUsersPassword.vue?vue&type=template&id=2d636ea5&scoped=true&"
import script from "./UpdateUsersPassword.vue?vue&type=script&lang=js&"
export * from "./UpdateUsersPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d636ea5",
  null
  
)

export default component.exports